module.exports = __webpack_public_path__ + "img/電気回路_2_9_1.b8b06325.png";